@if (loading.isBusy()) {
  <output class="global-loading-overlay fixed inset-0 flex items-center justify-center z-[9999]" aria-live="polite">
    <div class="global-loading-card flex flex-col items-center gap-2">
      <mat-spinner diameter="64"></mat-spinner>
      <p class="global-loading-text">
        @if (loading.customMessage()) {
          {{ loading.customMessage() }}
        } @else {
          {{ 'common.loading' | translate }}
        }
      </p>
    </div>
  </output>
}
